import i18n from 'helpers/i18n';
import messages from './messages';
import RouteHelpers from 'helpers/routes';
import { FormikHelpers } from 'formik';
import moment from 'moment';

export function getLockedMessage(error: any): string | undefined {
  if (!error?.locked_until) {
    return undefined;
  }

  const time = moment(error.locked_until).fromNow(true);
  return i18n.ft(messages.tryAgainIn, { time });
}

export function isAlreadyAuthenticatedError(error: any) {
  return Boolean(error?.errors?.user);
}

export function redirectToDashboard() {
  window.location.assign(RouteHelpers.getPath('app'));
}

export function getGenericErrorMessage() {
  return i18n.ft(messages.genericError);
}

/**
 * If the given error looks like a login error, it sets a message on the related input.
 * Returns a boolean indicating if an error was set for a login input.
 */
export function setLoginError(
  error: any,
  formik: FormikHelpers<any>,
  isFormWithPassword: boolean,
  values?: any
): boolean {
  const isLoginError = Boolean(error?.error) || Boolean(error?.locked_until);

  if (!isLoginError) {
    return false;
  }

  const lockedMessage = getLockedMessage(error);

  if (isFormWithPassword) {
    const incorrectMessage = values?.user?.login_phone
      ? messages.incorrectPhoneOrPassword
      : messages.incorrectEmailOrPassword;

    formik.setFieldError(
      'password',
      lockedMessage ?? i18n.ft(incorrectMessage)
    );
  } else {
    formik.setFieldError(
      'code',
      lockedMessage ?? i18n.ft(messages.incorrectCode)
    );
  }

  return true;
}
